(function () {
  var currentScript = document.currentScript;
  var sectionId = currentScript && currentScript.dataset.sectionId;
  if (!sectionId) return;

  var shell = document.querySelector('[data-bc-concept-section="' + sectionId + '"]');
  var mount = shell && shell.querySelector('[data-bc-concept-mount]');
  var configNode = document.getElementById('BCConceptConfig-' + sectionId);
  if (!mount || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var busy = false;
  var products = config.products || {};
  var heatSelections = {};
  /* Seven unless somebody says five. A full week is what the counter assumes, it is the better
   * price per meal, and the five-meal plan is one tap away in the panel. */
  var heatPlanSize = (function () { try { return new URLSearchParams(window.location.search).get('plan') === '5' ? 5 : 7; } catch (e) { return 7; } })();
  var heatPurchaseMode = 'bundle';
  var heatPickupMode = 'monday';
  var heatRenderedSchedule = null;
  var heatEditGroup = config.pageKey === 'heat-eat' ? new URLSearchParams(window.location.search).get('edit_meal') : null;
  var heatEditing = null;
  var heatEditLoading = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cents(value) {
    return Number(value || 0);
  }

  function money(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents(value) / 100);
  }

  function localDate(offsetDays) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date(Date.now() + (offsetDays || 0) * 86400000));
    var out = {};
    parts.forEach(function (part) { out[part.type] = part.value; });
    return out.year + '-' + out.month + '-' + out.day;
  }

function pacificPickupEpoch(date, time) {
  const match = /^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i.exec(time || '');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '') || !match) return NaN;
  let hour = Number(match[1]);
  const minute = Number(match[2]);
  if (minute > 59 || hour > (match[3] ? 12 : 23) || (match[3] && hour < 1)) return NaN;
  if (match[3]) hour = hour % 12 + (match[3].toUpperCase() === 'PM' ? 12 : 0);
  const [year, month, day] = date.split('-').map(Number);
  const wall = Date.UTC(year, month - 1, day, hour, minute);
  if (new Date(wall).toISOString().slice(0, 10) !== date) return NaN;
  let epoch = wall;
  const formatter = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  for (let i = 0; i < 3; i++) {
    const parts = Object.fromEntries(formatter.formatToParts(new Date(epoch)).map(part => [part.type, part.value]));
    epoch += wall - Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute));
  }
  const parts = Object.fromEntries(formatter.formatToParts(new Date(epoch)).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}` === date && Number(parts.hour) === hour && Number(parts.minute) === minute ? epoch : NaN;
}

function trayPickupValid(date, time, now = Date.now()) {
  const epoch = pacificPickupEpoch(date, time);
  const hour = Number(new Intl.DateTimeFormat('en-US', {timeZone:'America/Los_Angeles',hour:'2-digit',hourCycle:'h23'}).format(new Date(Number.isFinite(epoch) ? epoch : 0)));
  return Number.isFinite(epoch) && hour >= 9 && hour <= 20 && /:00(?:\s*[AP]M)?$/i.test(time || '') && epoch >= now + 86400000;
}


  function heatScheduleAt(epoch) {
    var parts = {};
    new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date(epoch)).forEach(function (part) { parts[part.type] = part.value; });
    var today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    var day = today.getUTCDay();
    var monday = new Date(today);
    monday.setUTCDate(today.getUTCDate() + ((8 - day) % 7 || 7) + (day === 6 || day === 0 ? 7 : 0));
    var cutoff = new Date(monday);
    cutoff.setUTCDate(monday.getUTCDate() - 3);
    var closeWall = new Date(cutoff);
    closeWall.setUTCHours(20, 0, 0, 0);
    var closeEpoch = closeWall.getTime();
    for (var attempt = 0; attempt < 3; attempt += 1) {
      var wall = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date(closeEpoch)).forEach(function (part) { wall[part.type] = part.value; });
      var represented = Date.UTC(Number(wall.year), Number(wall.month) - 1, Number(wall.day), Number(wall.hour), Number(wall.minute), Number(wall.second));
      closeEpoch += closeWall.getTime() - represented;
    }
    var iso = function (date) { return date.toISOString().slice(0, 10); };
    var label = function (date) { return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric' }).format(date); };
    return { pickupIso: iso(monday), pickupLabel: label(monday), cutoffIso: iso(cutoff), cutoffLabel: label(cutoff), cutoffTimeLabel: '8:00 PM Pacific', cutoffAt: new Date(closeEpoch).toISOString(), window: '2:00–7:00 PM' };
  }

  function heatPickupSchedule() {
    if (!heatRenderedSchedule) heatRenderedSchedule = heatScheduleAt(Date.now());
    return heatRenderedSchedule;
  }

  function heatPickupProperties(schedule, pickupTime, parentHandle, mealOrderId, mealRole) {
    return {
      'Pickup date': friendlyDate(schedule.pickupIso),
      'Pickup time': pickupTime,
      'Pickup timezone': 'America/Los_Angeles',
      'Order cutoff': friendlyDate(schedule.cutoffIso) + ', ' + schedule.cutoffTimeLabel,
      'Fulfillment': 'Pickup at Buon Cibo, 10380 Spring Canyon Road',
      '_Service date': schedule.pickupIso,
      '_Order cutoff': schedule.cutoffAt,
      '_Meal order': mealOrderId,
      '_Meal role': mealRole,
      '_Parent meal': parentHandle,
    };
  }

  function nextMonday() {
    var weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short' }).format(new Date());
    var index = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(weekday);
    var ahead = (1 - index + 7) % 7;
    if (ahead === 0) ahead = 7;
    return localDate(ahead);
  }

  function friendlyDate(dateValue) {
    if (!dateValue) return '';
    var date = new Date(dateValue + 'T12:00:00-07:00');
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }).format(date);
  }

  function cleanProductTitle(title) {
    return String(title || '').replace(/^Heat & Eat\s*[—-]\s*/i, '').replace(/^Family Tray\s*[—-]\s*/i, '').trim();
  }

  function toast(message, isError) {
    var node = mount.querySelector('[data-bc-commerce-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'bc-commerce-toast';
      node.setAttribute('data-bc-commerce-toast', '');
      node.setAttribute('role', isError ? 'alert' : 'status');
      mount.appendChild(node);
    }
    node.textContent = message;
    node.hidden = false;
    node.style.background = isError ? '#7a2c20' : '#0f4147';
    window.clearTimeout(node.bcTimer);
    node.bcTimer = window.setTimeout(function () { node.hidden = true; }, 5000);
  }

  function setBusy(button, value, label) {
    busy = value;
    if (!button) return;
    if (value) {
      button.dataset.bcOriginalLabel = button.textContent;
      button.textContent = label || 'Adding…';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.bcOriginalLabel || button.textContent;
      button.disabled = false;
    }
  }

  function addItems(items, button, successMessage) {
    if (busy || !items.length) return Promise.resolve(false);
    setBusy(button, true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Shopify could not add that selection.'); });
        return response.json();
      })
      .then(function (result) {
        try {
          if (window.BuonCiboAnalytics && typeof window.BuonCiboAnalytics.trackAddToCart === 'function') {
            window.BuonCiboAnalytics.trackAddToCart(result.items || result, items.map(function (item) { return { id: item.id, quantity: item.quantity }; }));
          }
        } catch (error) { /* Analytics must not interrupt a confirmed cart addition. */ }
        toast(successMessage || 'Added to your Shopify cart.', false);
        /* Say so on the button itself, and hold it there long enough to be read. It used to
         * navigate in the same tick, so the only confirmation anybody saw was the page
         * changing under them. */
        if (button) button.textContent = '\u2713 Added \u00b7 opening your cart';
        window.setTimeout(function () { window.location.assign('/cart'); }, 750);
        return true;
      })
      .catch(function (error) {
        toast(error.message || 'That selection could not be added.', true);
        /* Only a failure hands the button back. On success it stays disabled until the
         * page has gone: re-enabling it during the redirect left a window in which a second
         * press added a second plan. */
        setBusy(button, false);
        return false;
      });
  }

  /* Back from the cart. A browser may restore this page from its back/forward cache exactly
   * as it was left - button disabled, reading "Added". Nothing re-runs on a cached restore
   * except pageshow, so the state is reset here. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    busy = false;
    Array.from(document.querySelectorAll('[data-bc-original-label]')).forEach(function (control) {
      control.textContent = control.dataset.bcOriginalLabel;
      control.disabled = false;
    });
    try { renderHeatPhotoExperience(); } catch (error) { /* not the Heat & Eat page */ }
  });

  function findTextNode(root, text) {
    return Array.from(root.querySelectorAll('h1, h2, h3, p, span, div')).find(function (node) {
      return !node.children.length && (node.textContent || '').replace(/\s+/g, ' ').trim() === text;
    });
  }

  function preorderPanel(product, kind, compact) {
    if (!product || !product.handle) return null;
    var panel = document.createElement('div');
    panel.className = 'bc-commerce bc-preorder-commerce' + (compact ? ' bc-preorder-commerce--card' : '');
    panel.setAttribute('data-bc-preorder-commerce', kind);
    panel.innerHTML =
      '<span class="bc-preorder-commerce__eyebrow">Complete your order</span>' +
      '<h3 class="bc-preorder-commerce__heading">Choose servings, pickup time, and add-ons next.</h3>' +
      '<p class="bc-preorder-commerce__meta">Nothing is added from this listing. Review the full meal and every available extra on the product page.</p>' +
      '<a class="bc-commerce__button" href="/products/' + escapeHtml(product.handle) + '">Choose servings &amp; add-ons</a>';
    return panel;
  }

  function replaceTextContent(root, replacements) {
    Array.from(root.querySelectorAll('h1, h2, h3, p, span, div')).forEach(function (node) {
      if (node.children.length) return;
      var value = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (Object.prototype.hasOwnProperty.call(replacements, value)) node.textContent = replacements[value];
    });
  }

  function replaceRenderedText(root, replacements) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var value = node.nodeValue;
      replacements.forEach(function (rule) { value = value.replace(rule[0], rule[1]); });
      if (value !== node.nodeValue) node.nodeValue = value;
    });
  }

  /* The catering guest-count slider is injected by the loader and its readout never moved: the
   * panel it lives in is cloned by the runtime, and a listener bound to the input goes with the
   * original. Delegated from the mount, it survives. */
  function connectGuestSlider() {
    if (document.documentElement.hasAttribute('data-bc-guest-slider')) return;
    document.documentElement.setAttribute('data-bc-guest-slider', '');
    var paint = function (range) {
      var scope = range.closest('[data-bc-catering-inquiry]') || document;
      var out = scope.querySelector('[data-bc-catering-guests-output]');
      if (!out) return;
      var n = Number(range.value) || 0;
      out.textContent = (n >= Number(range.max) ? n + '+' : n) + ' guests';
    };
    /* The runtime handles input events in the bubble phase by re-applying the value it knows,
     * which for this injected control is the 30 it was born with - so every drag snapped straight
     * back and no readout could ever change. Paint here, in capture, and stop the event going any
     * further: this control is ours, and nothing downstream needs it. The value is read straight
     * off the input when the form is sent. */
    ['input', 'change'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var range = event.target;
        if (!range || !range.hasAttribute || !range.hasAttribute('data-bc-catering-guests')) return;
        paint(range);
        event.stopPropagation();
      }, true);
    });
  }

  function connectPreorder() {
    if (config.pageKey !== 'preorder') return;
    var primary = products.primary;
    var secondary = products.secondary;
    if (!primary) return;

    replaceTextContent(mount, {
      'Ordering for the week of August 3': 'Ordering for the week of August 10',
      'Preorder · week of August 3': 'Preorder · week of August 10',
      'Friday, August 7 · pickup 4 to 7': 'Friday, August 14 · pickup 4:00 to 7:00 PM',
      'Friday, August 7': 'Friday, August 14',
      'This Friday: rigatoni al sugo, for two.': 'This Friday: chicken artichoke piccata, for two.',
      'Rigatoni al sugo, Sicilian meatballs and sausage, Caesar, garlic bread, two cannoli.': 'Chicken with artichoke piccata sauce and mashed potatoes.',
      'This Friday: rigatoni al sugo, for two.': 'This Friday: chicken artichoke piccata, for two.',
      'Friday Dinner · Rigatoni al Sugo': 'Friday Dinner · Chicken Artichoke Piccata',
      'One menu, cooked once. The sauce goes on Thursday morning and comes off Friday afternoon, and we stop when the trays are empty.': 'Tender chicken with a garlic, butter, white wine, caper, and artichoke piccata sauce, served with creamy mashed potatoes.',
      'The sauce goes on Thursday morning and comes off Friday afternoon. Meatballs and sausage from the family recipe, Caesar, garlic bread, and two cannoli in the box.': 'Chicken with artichoke piccata sauce, served with creamy mashed potatoes.',
      'Sunday, August 9 · pickup 11 to 4': 'Sunday, August 16 · pickup 4:00 to 7:00 PM',
      'Sunday, August 9': 'Sunday, August 16',
      'Sugo Sunday Tray': 'Lasagna Sunday for Two',
      'Sauce simmering since Saturday morning, layered Sunday, baked in the tray it comes home in. Two plates, garlic bread, and enough to argue over the last corner. Add meatballs by the six.': 'A quarter tray of meat lasagna made from the Tarantino family recipe, served with garlic bread.',
      'Sunday 11–4 · $42': 'Sunday 4:00–7:00 PM · $35',
      '$58': '$35',
      '$48': '$35',
      '$58 for two': '$35 for two',
      '$48 for two': '$35 for two',
      '12 of 40 left': 'Up to 70 available',
      '12 left': 'Up to 70 available',
      '18 of 30 left': 'Up to 70 available',
    });

    replaceRenderedText(mount, [
      [/The sauce goes on Thursday morning and comes off Friday afternoon\. Meatballs and sausage from the family recipe, Caesar, garlic bread, and two cannoli in the box\./g, 'Chicken with artichoke piccata sauce, served with creamy mashed potatoes.'],
      [/Sauce simmering since Saturday morning, layered Sunday, baked in the tray it comes home in\. Two plates, garlic bread, and enough to argue over the last corner\. Add meatballs by the six\./g, 'A quarter tray of meat lasagna made from the Tarantino family recipe, served with garlic bread.'],
    ]);

    Array.from(mount.querySelectorAll('img')).forEach(function (image) {
      var alt = image.alt || '';
      if (primary.featuredImage && /sugo|rigatoni/i.test(alt)) {
        image.src = primary.featuredImage;
        image.alt = primary.title;
      }
      if (secondary && secondary.featuredImage && /house lasagna|two plates/i.test(alt)) {
        image.src = secondary.featuredImage;
        image.alt = secondary.title;
      }
    });

    Array.from(mount.querySelectorAll('button')).forEach(function (button) {
      var label = (button.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^Reserve this Friday$/i.test(label) && !button.dataset.bcCommerceConnected) {
        button.dataset.bcCommerceConnected = 'true';
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign('/products/' + primary.handle);
        }, true);
      }
    });

    var fridayHeading = findTextNode(mount, 'This Friday: chicken artichoke piccata, for two.');
    var fridaySection = fridayHeading && fridayHeading.closest('section');
    if (fridaySection && !fridaySection.querySelector('[data-bc-preorder-commerce="friday"]')) {
      var fridayButton = Array.from(fridaySection.querySelectorAll('button')).find(function (button) { return /Reserve this Friday/i.test(button.textContent || ''); });
      var fridayPanel = preorderPanel(primary, 'friday', true);
      if (fridayPanel && fridayButton) {
        fridayButton.closest('div').insertAdjacentElement('beforebegin', fridayPanel);
        fridayButton.hidden = true;
      }
    }

    if (secondary) {
      var sundayHeading = findTextNode(mount, 'This Sunday: lasagna for two.');
      var sundaySection = sundayHeading && sundayHeading.closest('section');
      if (sundaySection && !sundaySection.querySelector('[data-bc-preorder-commerce="sunday"]')) {
        var sundayButton = Array.from(sundaySection.querySelectorAll('button')).find(function (button) { return /Reserve this Sunday/i.test(button.textContent || ''); });
        var sundayPanel = preorderPanel(secondary, 'sunday', true);
        if (sundayPanel && sundayButton) {
          sundayButton.closest('div').insertAdjacentElement('beforebegin', sundayPanel);
          sundayButton.hidden = true;
        }
      }
    }

    Array.from(mount.querySelectorAll('article')).forEach(function (article) {
      var heading = article.querySelector('h2, h3');
      if (!heading) return;
      if (/Wine Night at the Wall|Ravioli of the Week|Every Friday, automatically/i.test(heading.textContent || '')) article.hidden = true;
    });
  }

  function heatProduct(tag) {
    return (products.heatEat || []).find(function (product) { return (product.tags || []).indexOf(tag) !== -1; });
  }

  function heatProductByName(name, typeTag) {
    function normalize(value) {
      return cleanProductTitle(value)
        .replace(/(?:six|6)\s+per\s+container/gi, '')
        .replace(/[^a-z0-9]+/gi, '')
        .toLowerCase();
    }
    var normalized = normalize(name);
    return (products.heatEat || []).find(function (product) {
      if (typeTag && (product.tags || []).indexOf(typeTag) === -1) return false;
      return normalize(product.title) === normalized;
    });
  }

  function selectionRows() {
    var rows = [];
    var panels = Array.from(mount.querySelectorAll('#meals [data-bc-heat-checkout]'));
    var card = panels[panels.length - 1];
    var sidebar = card && card.parentElement;
    if (!sidebar) return rows;
    var list = sidebar.querySelector('div[style*="display: grid"][style*="margin-bottom: 20px"]');
    if (!list) return rows;
    Array.from(list.children).forEach(function (row) {
      var label = Array.from(row.querySelectorAll('span')).find(function (span) { return /[A-Za-z]/.test(span.textContent || ''); });
      if (!label) return;
      var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
      var match = text.match(/\s×\s(\d+)$/);
      rows.push({ name: text.replace(/\s×\s\d+$/, ''), quantity: match ? Number(match[1]) : 1 });
    });
    return rows;
  }

  function heatProductForSavedMealName(name) {
    var savedName = String(name).toLowerCase();
    var oldWhiteFishNames = [
      'baked breaded cod fish with scampi sauce',
      'baked breaded cod fish',
      'baked breaded cod, scampi sauce'
    ];
    return heatMealProducts().find(function (item) {
      if (cleanProductTitle(item.title).toLowerCase() === savedName) return true;
      return item.handle === 'heat-eat-baked-breaded-cod-fish-with-scampi-sauce' && oldWhiteFishNames.indexOf(savedName) !== -1;
    });
  }

  function restoreHeatEdit() {
    if (!heatEditGroup || heatEditLoading || !mount.querySelector('[data-bc-heat-photo-builder]')) return;
    heatEditLoading = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Your cart could not be loaded.'); return response.json(); })
      .then(function (cart) {
        var lines = (cart.items || []).filter(function (item) { return item.properties && item.properties['_Meal order'] === heatEditGroup; });
        var mains = lines.filter(function (item) { return item.properties['_Meal role'] === 'main' && item.properties.Plan; });
        if (!mains.length) throw new Error('That plan is no longer in your cart. Start a new plan or return to your cart.');
        var size = /^7\b/.test(mains[0].properties.Plan) ? 7 : 5;
        var nextSelections = {};
        mains.forEach(function (line) {
          Object.keys(line.properties).filter(function (key) { return /^Meal \d+$/.test(key); }).sort(function (a, b) { return Number(a.slice(5)) - Number(b.slice(5)); }).forEach(function (key) {
            var name = String(line.properties[key]).toLowerCase();
            var product = heatProductForSavedMealName(name);
            if (!product) throw new Error('A meal in this plan is no longer on the current menu. Your cart is unchanged; call us to adjust it.');
            nextSelections[product.handle] = (nextSelections[product.handle] || 0) + 1;
          });
        });
        var nextAddons = {};
        lines.filter(function (line) { return line.properties['_Meal role'] === 'addon'; }).forEach(function (line) {
          var addon = heatAddonProducts().find(function (item) { return String(item.variantId) === String(line.variant_id); });
          if (!addon) throw new Error('An extra in this plan is no longer on the current menu. Your cart is unchanged; call us to adjust it.');
          nextAddons[addon.handle] = (nextAddons[addon.handle] || 0) + line.quantity;
        });
        var count = Object.values(nextSelections).reduce(function (sum, quantity) { return sum + quantity; }, 0);
        if (!count || count % size) throw new Error('This plan could not be opened for editing. Your cart is unchanged.');
        heatPlanSize = size;
        heatSelections = nextSelections;
        heatAddons = nextAddons;
        heatEditing = { group: heatEditGroup };
        renderHeatPhotoExperience();
        var panel = mount.querySelector('[data-bc-heat-checkout]');
        var note = panel && panel.querySelector('[data-bc-heat-edit-note]');
        if (note) {
          note.textContent = 'Editing the plan in your cart. Your current plan stays there until you save. Review the pickup date before saving.';
          note.hidden = false;
        }
        var priorSlot = mains[0].properties['Pickup time'];
        var slot = panel && Array.from(panel.querySelectorAll('input[name="bc-heat-slot"]')).find(function (input) { return input.value === priorSlot; });
        if (slot) { slot.checked = true; slot.dispatchEvent(new Event('change', { bubbles: true })); }
      })
      .catch(function (error) { toast(error.message || 'Your plan could not be opened. Your cart is unchanged.', true); });
  }

  /* One thing that follows you down the Heat & Eat page, and says the one thing worth saying at
   * each point: get me to the meals, then how many you have picked, then that the plan is ready.
   *
   * It is one control rather than two because two would be a floating button and a floating
   * counter arguing over the same corner. It hides while the order panel is on screen - you are
   * looking at the thing it points to - and it lifts clear of the Shopify preview bar when one is
   * present, which is the only reason the owner would not see it.
   */
  function heatStickyBar() {
    var existing = document.querySelector('[data-bc-heat-sticky]');
    if (existing) return existing;
    if (!document.querySelector('[data-bc-heat-photo-builder]')) return null;

    var bar = document.createElement('a');
    bar.className = 'bc-heat-sticky';
    bar.setAttribute('data-bc-heat-sticky', '');
    bar.href = '#meals';
    if (document.getElementById('PBarNextFrame') || document.querySelector('#preview-bar-iframe')) {
      bar.classList.add('is-previewing');
    }
    document.body.appendChild(bar);

    bar.addEventListener('click', function (event) {
      var target = document.querySelector(bar.getAttribute('data-target') || '#meals');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* Out of the way while the order panel is on screen - you are looking at what it points to -
     * and while the trays are, because a tray is not part of a meal plan and the bar would be
     * offering to build one over the top of it. */
    if ('IntersectionObserver' in window) {
      var hideOver = [document.querySelector('.bc-heat-photo__summary'), document.getElementById('trays')].filter(Boolean);
      var covering = new Set();
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) covering.add(entry.target);
          else covering.delete(entry.target);
        });
        bar.classList.toggle('is-hidden', covering.size > 0);
      }, { rootMargin: '-40px 0px -120px 0px' });
      hideOver.forEach(function (node) { watcher.observe(node); });
    }
    return bar;
  }

  function renderHeatSticky(count, size, ready, total) {
    var bar = heatStickyBar();
    if (!bar) return;
    /* What the control is worth at this moment, rather than what it is called. "Build my meals" is
     * a feature name; "Pick my 7 meals - $85" is the offer. Mid-plan the useful number is not how
     * many are in, it is how many are left to reach the price. */
    var label;
    var planPrice = heatPlanPrice(size);
    if (!count) {
      label = 'Pick my ' + size + ' meals · $' + planPrice;
      bar.setAttribute('data-target', '#meals');
    } else if (ready) {
      label = 'See my plan · $' + total;
      bar.setAttribute('data-target', '.bc-heat-photo__summary');
    } else {
      var left = size - (count % size);
      label = left + ' more for the $' + planPrice + ' plan';
      bar.setAttribute('data-target', '.bc-heat-photo__summary');
    }
    bar.classList.toggle('is-ready', !!ready);
    if (bar.textContent !== label) bar.textContent = label;
  }

  function renderHeatPanel(panel) {
    if (!panel) return;
    var rows = selectionRows();
    var count = rows.reduce(function (sum, row) { return sum + row.quantity; }, 0);
    var modeInput = panel.querySelector('input[name^="bc-heat-mode-"]:checked');
    var button = panel.querySelector('[data-bc-commerce-action="heat-add"]');
    var summary = panel.querySelector('[data-bc-heat-summary]');
    if (!modeInput || !button || !summary) return;
    var mode = modeInput.value;
    if (!count) {
      var emptyText = mode === 'bundle' ? 'Choose exactly five meals for the $75 bundle.' : 'Choose one or more meals above.';
      if (summary.textContent !== emptyText) summary.textContent = emptyText;
      button.disabled = true;
    } else if (mode === 'bundle' && count !== 5) {
      var remainingText = count + ' selected · choose ' + (count < 5 ? 5 - count + ' more' : 'remove ' + (count - 5)) + ' for the $75 bundle.';
      if (summary.textContent !== remainingText) summary.textContent = remainingText;
      button.disabled = true;
    } else {
      var total = rows.reduce(function (sum, row) {
        var product = heatProductByName(row.name, 'bc-heat-eat-item');
        return sum + (product ? cents(product.price) * row.quantity : 0);
      }, 0);
      var readyText = mode === 'bundle' ? 'Five meals selected · $75 total.' : count + ' meal' + (count === 1 ? '' : 's') + ' · ' + money(total) + ' total.';
      if (summary.textContent !== readyText) summary.textContent = readyText;
      button.disabled = false;
      var buttonText = mode === 'bundle' ? 'Add five-meal bundle · $75' : 'Add selected meals · ' + money(total);
      if (button.textContent !== buttonText) button.textContent = buttonText;
    }
  }

  function pruneDuplicateCommercePanels() {
    var heatPanels = Array.from(mount.querySelectorAll('#meals [data-bc-heat-checkout]'));
    if (heatPanels.length > 1) {
      heatPanels.slice(0, -1).forEach(function (panel) { panel.remove(); });
    }
    ['friday', 'sunday'].forEach(function (kind) {
      var panels = Array.from(mount.querySelectorAll('[data-bc-preorder-commerce="' + kind + '"]'));
      if (panels.length > 1) panels.slice(0, -1).forEach(function (panel) { panel.remove(); });
    });
  }

  function heatCheckoutPanel(sidebarCard) {
    var panel = document.createElement('div');
    panel.className = 'bc-commerce bc-heat-commerce';
    panel.setAttribute('data-bc-heat-checkout', '');
    panel.innerHTML =
      '<div class="bc-commerce__legend">How would you like to buy these?</div>' +
      '<div class="bc-heat-commerce__modes">' +
        '<label class="bc-heat-commerce__choice"><input type="radio" name="bc-heat-mode-' + escapeHtml(sectionId) + '" value="bundle" checked><span>5 meals · $75</span></label>' +
        '<label class="bc-heat-commerce__choice"><input type="radio" name="bc-heat-mode-' + escapeHtml(sectionId) + '" value="individual"><span>Individual prices</span></label>' +
      '</div>' +
      '<div class="bc-commerce__legend">Pickup date</div>' +
      '<div class="bc-heat-commerce__dates">' +
        '<label class="bc-heat-commerce__choice"><input type="radio" name="bc-heat-date-mode-' + escapeHtml(sectionId) + '" value="monday" checked><span>Monday · ' + escapeHtml(friendlyDate(nextMonday()).replace(/, \d{4}$/, '')) + '</span></label>' +
        '<label class="bc-heat-commerce__choice"><input type="radio" name="bc-heat-date-mode-' + escapeHtml(sectionId) + '" value="custom"><span>Choose another date</span></label>' +
      '</div>' +
      '<label class="bc-commerce__field" data-bc-custom-date-wrap hidden><span>Requested pickup date</span><input type="date" min="' + escapeHtml(localDate(0)) + '" value="' + escapeHtml(nextMonday()) + '" data-bc-heat-date></label>' +
      '<p class="bc-heat-commerce__summary" data-bc-heat-summary>Choose exactly five meals for the $75 bundle.</p>' +
      '<button class="bc-commerce__button" type="button" data-bc-commerce-action="heat-add" disabled>Add to cart</button>' +
      '<p class="bc-commerce__status" data-bc-heat-status aria-live="polite"></p>';

    function render() { renderHeatPanel(panel); }

    panel.addEventListener('change', function (event) {
      if (event.target.name && event.target.name.indexOf('bc-heat-date-mode-') === 0) {
        panel.querySelector('[data-bc-custom-date-wrap]').hidden = event.target.value !== 'custom';
      }
      render();
    });

    panel.querySelector('[data-bc-commerce-action]').addEventListener('click', function (event) {
      var rows = selectionRows();
      var mode = panel.querySelector('input[name^="bc-heat-mode-"]:checked').value;
      var dateMode = panel.querySelector('input[name^="bc-heat-date-mode-"]:checked').value;
      var pickupDate = dateMode === 'monday' ? nextMonday() : panel.querySelector('[data-bc-heat-date]').value;
      if (!pickupDate) return toast('Choose a requested pickup date.', true);
      var properties = {
        'Pickup timing': dateMode === 'monday' ? 'Default Monday pickup' : 'Requested pickup date',
        'Requested pickup date': friendlyDate(pickupDate),
        'Fulfillment': 'Pickup at Buon Cibo',
      };
      var items = [];
      if (mode === 'bundle') {
        var bundle = heatProduct('bc-heat-eat-bundle');
        if (!bundle || !bundle.variants[0]) return toast('The five-meal bundle is not connected.', true);
        var mealNumber = 1;
        rows.forEach(function (row) {
          for (var index = 0; index < row.quantity; index += 1) {
            properties['Meal ' + mealNumber] = row.name;
            mealNumber += 1;
          }
        });
        items.push({ id: String(bundle.variants[0].id), quantity: 1, properties: properties });
      } else {
        rows.forEach(function (row) {
          var product = heatProductByName(row.name, 'bc-heat-eat-item');
          if (product && product.variants[0]) items.push({ id: String(product.variants[0].id), quantity: row.quantity, properties: Object.assign({}, properties) });
        });
      }
      addItems(items, event.currentTarget, 'Your Heat & Eat selection is in the cart.');
    });

    var observer = new MutationObserver(render);
    observer.observe(sidebarCard, { childList: true, subtree: true, characterData: true });
    window.setTimeout(render, 0);
    return panel;
  }

  /* Trays keep their own clock.
   *
   * They were borrowing the Heat & Eat schedule - order by Friday, collect Monday between 2 and 4 -
   * which is the meal plan's rule, not theirs. A tray needs a day's notice and nothing more, so it
   * can be collected any day from tomorrow, at any hour the shop is open.
   */
  var TRAY_OPEN_HOUR = 9;
  var TRAY_CLOSE_HOUR = 20;

  /* A week of days, as days.
   *
   * A date field is a text box that opens the operating system's calendar: the right control for a
   * birthday, and a heavy one for "tomorrow or the day after", which is what nearly every tray is.
   * These are the next seven days as chips, in our own type, with the native picker still there
   * behind "Another day" for anyone planning further out.
   */
  function pacificDate(epoch) {
    var parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(epoch)).map(function (part) { return [part.type, part.value]; }));
    return parts.year + '-' + parts.month + '-' + parts.day;
  }

  function calendarDate(iso, days) {
    var date = new Date(iso + 'T12:00:00Z');
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
  }

  function trayEarliestDate(now) {
    now = now === undefined ? Date.now() : now;
    var date = pacificDate(now + 86400000);
    if (!trayTimeOptions().some(function (slot) { return trayPickupValid(date, slot.value, now); })) date = calendarDate(date, 1);
    return date;
  }

  function trayDayOptions() {
    var now = Date.now(), first = trayEarliestDate(now), tomorrow = calendarDate(pacificDate(now), 1), out = [];
    for (var offset = 0; offset < 7; offset += 1) {
      var iso = calendarDate(first, offset), day = new Date(iso + 'T12:00:00Z');
      out.push({ value: iso, name: iso === tomorrow ? 'Tomorrow' : new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', weekday: 'long'}).format(day), date: day.getUTCDate() });
    }
    return out;
  }

  function trayTimeOptions() {
    var out = [];
    for (var hour = TRAY_OPEN_HOUR; hour <= TRAY_CLOSE_HOUR; hour += 1) {
      var suffix = hour >= 12 ? 'PM' : 'AM';
      var twelve = hour % 12 === 0 ? 12 : hour % 12;
      out.push({ value: (hour < 10 ? '0' : '') + hour + ':00', label: twelve + ':00 ' + suffix });
    }
    return out;
  }

  function trayPickupProperties(dateIso, timeLabel, handle) {
    return {
      'Pickup date': friendlyDate(dateIso),
      'Pickup time': timeLabel,
      'Pickup timezone': 'America/Los_Angeles',
      'Fulfillment': 'Pickup at Buon Cibo, 10380 Spring Canyon Road',
      '_Service date': dateIso,
      '_Tray order': crypto.randomUUID(),
      '_Parent tray': handle,
    };
  }

  function trayPanel(product) {
    if (!product || !product.variants.length) return null;
    var panel = document.createElement('div');
    panel.className = 'bc-commerce bc-tray-commerce';
    panel.setAttribute('data-bc-tray-commerce', product.handle);
    panel.innerHTML =
      '<label class="bc-commerce__field"><span>Tray size</span><select data-bc-tray-variant>' + product.variants.map(function (variant) {
        return '<option value="' + escapeHtml(variant.id) + '">' + escapeHtml(variant.title) + ' · ' + escapeHtml(money(variant.price)) + '</option>';
      }).join('') + '</select></label>' +
      '<div class="bc-tray-commerce__row"><label class="bc-commerce__field"><span>Pickup date</span><input type="date" min="' + escapeHtml(localDate(0)) + '" value="' + escapeHtml(nextMonday()) + '" data-bc-tray-date></label><label class="bc-commerce__field"><span>Qty</span><input type="number" min="1" max="12" value="1" data-bc-tray-quantity></label></div>' +
      '<button class="bc-commerce__button" type="button" data-bc-commerce-action="tray-add">Add tray to cart</button>';
    panel.querySelector('[data-bc-commerce-action]').addEventListener('click', function (event) {
      var variant = product.variants.find(function (item) { return String(item.id) === panel.querySelector('[data-bc-tray-variant]').value; });
      var date = panel.querySelector('[data-bc-tray-date]').value;
      var quantity = Math.max(1, Math.min(12, Number(panel.querySelector('[data-bc-tray-quantity]').value) || 1));
      if (!variant || !date) return toast('Choose a tray size and pickup date.', true);
      addItems([{
        id: String(variant.id),
        quantity: quantity,
        properties: {
          'Pickup timing': 'Requested pickup date',
          'Requested pickup date': friendlyDate(date),
          'Fulfillment': 'Pickup at Buon Cibo',
        },
      }], event.currentTarget, cleanProductTitle(product.title) + ' is in the cart.');
    });
    return panel;
  }

  function connectHeatEat() {
    if (config.pageKey !== 'heat-eat' || !(products.heatEat || []).length) return;
    pruneDuplicateCommercePanels();
    replaceTextContent(mount, {
      '7 meals': '5 meals',
      'Seven Meals. One Less Thing to Think About.': 'Five Meals. One Less Thing to Think About.',
      'for seven meals': 'for five meals',
      'Choose individual dishes, ask about our seven-meal assortment for $75, or bring home a family-style tray when you are feeding a larger table. Everything is made fresh and keeps in the refrigerator for up to five days.': 'Choose individual dishes, build your five-meal assortment for $75, or bring home a family-style tray when you are feeding a larger table.',
      'Take care of several lunches or dinners in one visit with our seven-meal Italian assortment for $75.': 'Take care of five lunches or dinners in one visit with our five-meal Italian assortment for $75.',
      'Stop by Buon Cibo and choose from a rotating case of Italian meals prepared for you to heat and serve at home. Pick up a few dishes for the busiest nights of the week, bring home our seven-meal assortment, or choose a family-style tray when everyone is coming to the table.': 'Choose individual meals online, build a five-meal assortment for $75, or order a family-style tray for pickup.',
      'Pick individual meals from the case, ask about the seven-meal assortment for $75, or choose a family-style tray.': 'Pick individual meals, build the five-meal assortment for $75, or choose a family-style tray.',
      'Tap the plus beside any meal to keep a list. Nothing is ordered here — it is something to read us over the phone.': 'Tap the plus beside any meal. Choose five for the $75 bundle, or buy dishes individually.',
      'Individual meals run $14 to $18 depending on the dish.': 'Individual meals are priced as shown in Shopify checkout.',
      'Individual meals are $14 to $18 depending on the dish. Prices and availability are confirmed in the store.': 'Individual meal prices are connected to Shopify. The grilled chicken remains priced by the pound; call for today’s price.',
      'Call and read us the list': 'Review your selections below',
    });

    replaceRenderedText(mount, [
      [/Seven Meals/g, 'Five Meals'],
      [/seven-meal/g, 'five-meal'],
      [/seven meals/g, 'five meals'],
      [/7 meals/g, '5 meals'],
      [/Individual meals run \$14 to \$18\s+depending on the dish\./g, 'Individual meals range from $12.50 to $16.50, as shown below.'],
      [/Individual meals are \$14 to \$18 depending on the dish\. Prices and availability are confirmed in the store\./g, 'Individual meal prices are connected to Shopify. The grilled chicken remains priced by the pound; call for today’s price.'],
      [/Everything is made fresh and keeps in the refrigerator for up to five days\./g, 'Choose your meals and requested pickup date below.'],
      [/Everything is made fresh, so keep it refrigerated and plan on it within about five days\. Heat it when you are ready and eat a different Italian dinner without starting from scratch\./g, 'Keep meals refrigerated and follow the reheating instructions provided at pickup.'],
      [/Made fresh and sold cold, good in the refrigerator for up to five days/g, 'Prepared by Buon Cibo and packaged for pickup'],
      [/A few more and the five-meal assortment at \$75 costs less than picking them one by one\. Ask what is in it this week\./g, 'Your five-meal bundle is ready for checkout below.'],
      [/That is five or more\. The assortment at \$75 is the cheaper way to do it — ask what is included this week\./g, 'Choose exactly five meals for the $75 bundle, or use individual pricing below.'],
      [/Call and read us the list/g, 'Review your selections below'],
    ]);

    /* The runtime can restore preserved text after its first render. Mark the
     * mount once the connected copy is present, then re-apply on later passes. */
    mount.setAttribute('data-bc-commerce-copy-connected', 'true');

    Array.from(mount.querySelectorAll('a')).forEach(function (link) {
      if (/Call to ask what is included this week/i.test(link.textContent || '')) {
        link.href = '#meals';
        link.textContent = 'Choose five meals';
      }
      if (/Call to Check Today’s Selection/i.test(link.textContent || '')) {
        link.href = '#meals';
        link.textContent = 'Choose meals';
      }
      if (/Review your selections below/i.test(link.textContent || '') && link.closest('#meals')) {
        link.hidden = true;
      }
    });

    Array.from(mount.querySelectorAll('div, span')).forEach(function (node) {
      if (node.children.length || (node.textContent || '').trim() !== '5 days') return;
      node.textContent = 'Pickup';
      var descriptor = node.nextElementSibling;
      if (descriptor && /Made fresh, good that long/i.test(descriptor.textContent || '')) descriptor.textContent = 'Choose a date';
    });

    Array.from(mount.querySelectorAll('#meals button')).forEach(function (button) {
      if ((button.textContent || '').trim() !== '+') return;
      var row = button.parentElement;
      var label = row && Array.from(row.querySelectorAll('span')).find(function (span) { return /[A-Za-z]/.test(span.textContent || ''); });
      var product = label && heatProductByName(label.textContent || '', 'bc-heat-eat-item');
      if (!product || row.querySelector('[data-bc-meal-price]')) return;
      var price = document.createElement('span');
      price.setAttribute('data-bc-meal-price', '');
      price.style.marginLeft = 'auto';
      price.style.fontSize = '15px';
      price.style.fontWeight = '600';
      price.style.whiteSpace = 'nowrap';
      price.textContent = money(product.price);
      row.appendChild(price);
    });

    var listHeading = findTextNode(mount, 'Your list');
    var sidebarCard = listHeading && listHeading.parentElement;
    if (sidebarCard && !sidebarCard.querySelector('[data-bc-heat-checkout]')) {
      var heatPanel = heatCheckoutPanel(sidebarCard);
      var clearButton = Array.from(sidebarCard.querySelectorAll('button')).find(function (button) { return /^Start over$/i.test((button.textContent || '').trim()); });
      if (clearButton) clearButton.insertAdjacentElement('beforebegin', heatPanel);
      else sidebarCard.appendChild(heatPanel);
    }
    renderHeatPanel(sidebarCard && sidebarCard.querySelector('[data-bc-heat-checkout]'));

    var traysSection = mount.querySelector('#trays');
    if (traysSection) {
      Array.from(traysSection.querySelectorAll('article')).forEach(function (article) {
        var heading = article.querySelector('h3');
        if (!heading || article.querySelector('[data-bc-tray-commerce]')) return;
        var product = heatProductByName(heading.textContent || '', 'bc-heat-eat-tray');
        var panel = trayPanel(product);
        if (panel) article.appendChild(panel);
      });
    }
  }

  /* Photo-first Heat & Eat ordering. These declarations intentionally replace
   * the legacy text-list adapter above while the preserved concept remains the
   * source for the approved hero, narrative sections, header, and footer. */
  /* Chosen add-ons, by handle -> quantity. Separate from heatSelections because these are
   * not part of the plan and must never count toward the 5 or 7. */
  var heatAddons = {};

  function heatAddonProducts() {
    return (products.addons || []).filter(function (item) { return item && item.variantId; });
  }

  function heatAddonCount() {
    return Object.keys(heatAddons).reduce(function (sum, key) { return sum + heatAddons[key]; }, 0);
  }

  function heatAddonTotal() {
    return heatAddonProducts().reduce(function (sum, item) {
      return sum + (heatAddons[item.handle] || 0) * Number(item.price || 0);
    }, 0);
  }

  /* Shopify prices arrive in cents from Liquid's product.price. */
  function heatMoney(cents) {
    var value = Number(cents || 0) / 100;
    return '$' + (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2));
  }

  function heatMealProducts() {
    var order = [
      'heat-eat-eggplant-parmigiana',
      'heat-eat-rigatoni-pesto',
      'heat-eat-penne-vodka-and-peas',
      'heat-eat-cheese-lasagna',
      'heat-eat-mushroom-risotto',
      'heat-eat-penne-marinara-sauce',
      'heat-eat-meat-lasagna',
      'heat-eat-chicken-pesto-lasagna',
      'heat-eat-spaghetti-with-meatballs',
      'heat-eat-ravioli-with-marinara-sauce',
      'heat-eat-stuffed-bell-pepper',
      'heat-eat-chicken-parmigiana',
      'heat-eat-chicken-marsala',
      'heat-eat-baked-breaded-cod-fish-with-scampi-sauce',
      'heat-eat-meatballs-6-per-container',
    ];
    return (products.heatEat || [])
      .filter(function (product) { return (product.tags || []).indexOf('bc-heat-eat-item') !== -1; })
      .sort(function (a, b) {
        var aIndex = order.indexOf(a.handle);
        var bIndex = order.indexOf(b.handle);
        return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
      });
  }

  function heatProductByHandle(handle) {
    return (products.heatEat || []).find(function (product) { return product.handle === handle; });
  }

  function selectionRows() {
    return Object.keys(heatSelections).map(function (handle) {
      var product = heatProductByHandle(handle);
      return product ? {
        handle: handle,
        name: cleanProductTitle(product.title),
        quantity: heatSelections[handle],
      } : null;
    }).filter(Boolean);
  }

  function heatPlanProduct(size) {
    return heatProduct(size === 7 ? 'bc-heat-eat-bundle-7' : 'bc-heat-eat-bundle');
  }
  function heatPlanPrice(size) {
    var product = heatPlanProduct(size);
    var price = product && product.variants && product.variants[0] ? cents(product.variants[0].price) / 100 : 0;
    return price || (size === 7 ? 85 : 75);
  }
  function heatBundlePrice() {
    return heatPlanPrice(heatPlanSize);
  }

  function shortDate(dateValue) {
    var date = new Date(dateValue + 'T12:00:00Z');
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  function validateHeatDate(panel) {
    var schedule = heatPickupSchedule();
    if (Date.now() >= new Date(schedule.cutoffAt).getTime()) {
      var message = 'Ordering for this Monday pickup closed Friday at 8:00 PM Pacific. Return Saturday to reserve meals for the following Monday.';
      var status = panel && panel.querySelector('[data-bc-heat-status]');
      var button = panel && panel.querySelector('[data-bc-commerce-action]');
      if (status) { status.textContent = message; status.setAttribute('role', 'alert'); }
      if (button) { button.disabled = true; button.textContent = 'Ordering closed · Friday 8 PM'; }
      toast(message, true);
      return null;
    }
    return { value: schedule.pickupIso, mode: 'monday', schedule: schedule };
  }

  function renderHeatPanel(panel) {
    if (!panel) return;
    var rows = selectionRows();
    var count = rows.reduce(function (sum, row) { return sum + row.quantity; }, 0);
    var button = panel.querySelector('[data-bc-commerce-action="heat-add"]');
    var summary = panel.querySelector('[data-bc-heat-summary]');
    if (!button || !summary) return;

    var size = heatPlanSize;
    var price = heatPlanPrice(size);
    Array.from(panel.querySelectorAll('[data-bc-heat-plan]')).forEach(function (control) {
      control.setAttribute('aria-pressed', String(Number(control.getAttribute('data-bc-heat-plan')) === size));
    });
    var plans = Math.floor(count / size);
    var remainder = count % size;
    var unresolved = rows.some(function (row) {
      var product = heatProductByHandle(row.handle);
      return !product || !product.variants || !product.variants.some(function (variant) { return variant.available !== false; });
    });
    var planLabel = size + '-meal plan';
    var text;
    var hint = panel.querySelector('[data-bc-heat-hint]');
    var hintText = '';

    var closed = Date.now() >= Date.parse(heatPickupSchedule().cutoffAt);
    if (closed) {
      text = 'Ordering for this Monday pickup closed Friday at 8:00 PM Pacific. Return Saturday to reserve meals for the following Monday.';
      button.disabled = true;
      button.textContent = 'Ordering closed · Friday 8 PM';
    } else if (!count) {
      text = 'Pick any ' + size + ' meals from this week’s menu to claim your ' + planLabel + ' for $' + price + '.';
      button.disabled = true;
      button.textContent = 'Select ' + size + ' meals to continue';
    } else if (unresolved) {
      text = 'One of your selected meals is unavailable this week. Remove it to continue.';
      button.disabled = true;
      button.textContent = 'Review unavailable meals';
    } else if (remainder !== 0) {
      var remaining = size - remainder;
      if (!plans) {
        text = count + ' of ' + size + ' picked · Select ' + remaining + ' more to claim your ' + planLabel + '.';
      } else {
        text = plans + ' ' + planLabel + (plans === 1 ? '' : 's') + ' ready · ' + remainder + ' toward the next. Select ' + remaining + ' more, or remove ' + remainder + ' to check out.';
      }
      button.disabled = true;
      button.textContent = 'Select ' + remaining + ' more to claim your deal';
      if (size === 5 && count === 7) hintText = 'Seven picked? Switch to the 7-meal plan for $' + heatPlanPrice(7) + ' and check out now.';
      if (size === 7 && count === 5) hintText = 'Five picked? Switch to the 5-meal plan for $' + heatPlanPrice(5) + ' and check out now.';
    } else {
      var total = plans * price;
      text = (plans === 1 ? 'Your ' + planLabel + ' is ready' : plans + ' ' + planLabel + 's ready') + ' · ' + count + ' meals · $' + total + '.';
      button.textContent = 'Add ' + (plans === 1 ? planLabel : plans + ' ' + planLabel + 's') + ' · $' + total;
      button.disabled = false;
      if (size === 5 && plans === 1) hintText = 'Want a full week? Two more meals makes it the 7-meal plan for $' + heatPlanPrice(7) + '.';
    }
    if (summary.textContent !== text) summary.textContent = text;
    if (hint) { hint.textContent = hintText; hint.hidden = !hintText; }
    if (heatEditing && !button.disabled) button.textContent = 'Save changes · $' + (plans * price);
    renderHeatSticky(count, size, !closed && count > 0 && remainder === 0 && !unresolved, plans * price);

    /* The add-on block appears only once the plan is claimable. Offered earlier it competes
     * with the job the visitor is still doing; offered later there is nowhere to put it. */
    renderHeatAddons(panel, !closed && count > 0 && remainder === 0 && !unresolved);

    var addonTotal = heatAddonTotal();
    if (!button.disabled && addonTotal) {
      button.textContent = button.textContent + ' + ' + heatMoney(addonTotal) + ' extras';
    }
  }

  function renderHeatAddons(panel, open) {
    var host = panel.querySelector('[data-bc-heat-addons]');
    if (!host) return;
    var items = heatAddonProducts();
    if (!items.length) { host.hidden = true; return; }
    host.hidden = !open;
    if (!open || host.dataset.bcBuilt === 'true') { updateHeatAddonStates(host); return; }
    host.dataset.bcBuilt = 'true';
    host.innerHTML =
      '<p class="bc-heat-addons__lead"><strong>Make it a complete meal.</strong> ' +
      'Choose the number of each extra. Extras are priced separately, stay at the same pickup, and do not automatically increase when you add another plan.</p>' +
      '<ul class="bc-heat-addons__list">' +
        items.map(function (item) {
          return '<li class="bc-heat-addons__item" data-bc-addon="' + escapeHtml(item.handle) + '">' +
            (item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="96" height="96">'
              : '<span class="bc-heat-addons__blank" aria-hidden="true"></span>') +
            '<span class="bc-heat-addons__text">' +
              '<span class="bc-heat-addons__name">' + escapeHtml(item.title) + '</span>' +
              '<span class="bc-heat-addons__price">' + escapeHtml(heatMoney(item.price)) + '</span>' +
            '</span>' +
            '<span class="bc-heat-addons__quantity" role="group" aria-label="Quantity of ' + escapeHtml(item.title) + '">' +
              '<button type="button" data-bc-addon-step="-1" data-bc-addon-handle="' + escapeHtml(item.handle) + '" aria-label="Remove one ' + escapeHtml(item.title) + '">−</button>' +
              '<output data-bc-addon-count="' + escapeHtml(item.handle) + '">0</output>' +
              '<button type="button" data-bc-addon-step="1" data-bc-addon-handle="' + escapeHtml(item.handle) + '" aria-label="Add one ' + escapeHtml(item.title) + '">+</button>' +
            '</span>' +
          '</li>';
        }).join('') +
      '</ul>';

    updateHeatAddonStates(host);
  }

  function updateHeatAddonStates(host) {
    Array.from(host.querySelectorAll('[data-bc-addon-count]')).forEach(function (output) {
      var handle = output.getAttribute('data-bc-addon-count');
      var quantity = heatAddons[handle] || 0;
      output.textContent = String(quantity);
      var item = output.closest('.bc-heat-addons__item');
      if (item) item.classList.toggle('is-on', quantity > 0);
      var decrease = item && item.querySelector('[data-bc-addon-step="-1"]');
      var increase = item && item.querySelector('[data-bc-addon-step="1"]');
      if (decrease) decrease.disabled = quantity === 0;
      if (increase) increase.disabled = quantity >= 12;
    });
  }

  function renderHeatPhotoExperience() {
    var builder = mount.querySelector('[data-bc-heat-photo-builder]');
    if (!builder) return;
    var rows = selectionRows();
    var count = rows.reduce(function (sum, row) { return sum + row.quantity; }, 0);

    Array.from(builder.querySelectorAll('[data-bc-heat-meal-card]')).forEach(function (card) {
      var handle = card.getAttribute('data-bc-heat-meal-card');
      var quantity = heatSelections[handle] || 0;
      card.classList.toggle('is-selected', quantity > 0);
      var addButton = card.querySelector('[data-bc-heat-add]');
      var adjust = card.querySelector('[data-bc-heat-adjust]');
      var countNode = card.querySelector('[data-bc-heat-card-count]');
      if (addButton) addButton.hidden = quantity > 0;
      if (adjust) adjust.hidden = quantity < 1;
      if (countNode) countNode.textContent = String(quantity || 1);
    });

    var countNode = builder.querySelector('[data-bc-heat-count]');
    if (countNode) countNode.textContent = count ? count + ' of ' + heatPlanSize + ' picked' : 'Your plan';
    var list = builder.querySelector('[data-bc-heat-selected-list]');
    if (list) {
      list.innerHTML = rows.length ? rows.map(function (row) {
        return '<div class="bc-heat-photo__selected-row"><span>' + escapeHtml(row.name) + '</span><strong>× ' + row.quantity + '</strong></div>';
      }).join('') : '<p class="bc-heat-photo__empty">Your picks show up here. Choose ' + heatPlanSize + ' to claim your plan.</p>';
    }
    renderHeatPanel(builder.querySelector('[data-bc-heat-checkout]'));
  }

  // "2026-09-14" -> "Mon, Sep 14"
  function heatShortDate(iso) {
    return new Date(iso + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  // "2:00–7:00 PM" -> half-hour pickup choices inside that window.
  function heatSlots(windowText) {
    var match = String(windowText || '').match(/(\d{1,2}):(\d{2})\s*[–-]\s*(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!match) return [];
    var start = Number(match[1]) * 60 + Number(match[2]);
    var end = Number(match[3]) * 60 + Number(match[4]);
    var suffix = match[5].toUpperCase();
    var clock = function (mins) { var m = mins % 60; return Math.floor(mins / 60) + ':' + (m < 10 ? '0' : '') + m; };
    var slots = [];
    for (var t = start; t + 30 <= end; t += 30) {
      slots.push({ text: clock(t) + '–' + clock(t + 30), value: clock(t) + '–' + clock(t + 30) + ' ' + suffix });
    }
    return slots;
  }

  // The pickup time the guest chose, or the whole window when they left it open.
  function heatChosenSlot(panel, windowText) {
    var input = panel && panel.querySelector('input[name="bc-heat-slot"]:checked');
    return input && input.value ? input.value : windowText + ' (any time)';
  }

  function heatCheckoutPanel() {
    var schedule = heatPickupSchedule();
    var slots = heatSlots(schedule.window);
    var panel = document.createElement('div');
    panel.className = 'bc-commerce bc-heat-commerce';
    panel.setAttribute('data-bc-heat-checkout', '');
    panel.innerHTML =
      '<fieldset class="bc-heat-commerce__fieldset"><legend class="bc-commerce__legend">Your plan</legend>' +
        '<div class="bc-heat-commerce__modes">' +
          '<button class="bc-heat-commerce__choice" type="button" data-bc-heat-plan="5" aria-pressed="' + (heatPlanSize === 5) + '">5 meals · $' + heatPlanPrice(5) + '</button>' +
          '<button class="bc-heat-commerce__choice" type="button" data-bc-heat-plan="7" aria-pressed="' + (heatPlanSize === 7) + '">7 meals · $' + heatPlanPrice(7) + '</button>' +
        '</div>' +
      '</fieldset>' +
      '<div class="bc-heat-when" data-bc-heat-schedule>' +
        '<div class="bc-heat-when__row"><span class="bc-heat-when__eyebrow">Order by Friday</span><strong>' + escapeHtml(heatShortDate(schedule.cutoffIso)) + ' · ' + escapeHtml(schedule.cutoffTimeLabel) + '</strong></div>' +
        '<div class="bc-heat-when__row"><span class="bc-heat-when__eyebrow">Pick up on Mondays</span><strong>' + escapeHtml(heatShortDate(schedule.pickupIso)) + ' · ' + escapeHtml(schedule.window) + '</strong></div>' +
        (slots.length ?
          '<details class="bc-heat-when__time">' +
            '<summary><span class="bc-heat-when__eyebrow">Pickup time</span><strong data-bc-heat-slot-label>Anytime, ' + escapeHtml(schedule.window) + '</strong></summary>' +
            '<fieldset><legend>Choose a pickup time on ' + escapeHtml(schedule.pickupLabel) + '</legend>' +
              '<label class="bc-heat-when__slot"><input type="radio" name="bc-heat-slot" value="" checked><span>Anytime</span></label>' +
              slots.map(function (slot) {
                return '<label class="bc-heat-when__slot"><input type="radio" name="bc-heat-slot" value="' + escapeHtml(slot.value) + '"><span>' + escapeHtml(slot.text) + '</span></label>';
              }).join('') +
            '</fieldset>' +
          '</details>' : '') +
      '</div>' +
      '<div class="bc-heat-addons" data-bc-heat-addons hidden></div>' +
      '<p class="bc-heat-commerce__summary" data-bc-heat-summary aria-live="polite"></p>' +
      '<p class="bc-heat-commerce__hint" data-bc-heat-edit-note hidden></p>' +
      '<p class="bc-heat-commerce__hint" data-bc-heat-hint hidden></p>' +
      '<button class="bc-commerce__button" type="button" data-bc-commerce-action="heat-add" disabled>Select meals to continue</button>' +
      '<p class="bc-commerce__status" data-bc-heat-status aria-live="polite"></p>';

    panel.querySelector('[data-bc-commerce-action]').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      addHeatSelection(panel, event.currentTarget);
    });
    function updatePickupSlotLabel(event) {
      var option = event.target && event.target.closest && event.target.closest('.bc-heat-when__slot');
      var input = option && option.querySelector('input[name="bc-heat-slot"]');
      if (!input) return;
      var label = panel.querySelector('[data-bc-heat-slot-label]');
      if (label) label.textContent = input.value || 'Anytime, ' + schedule.window;
    }
    panel.addEventListener('change', updatePickupSlotLabel);
    panel.addEventListener('click', updatePickupSlotLabel);
    // Close an already-open builder at the deadline, and recheck after a background tab resumes.
    window.setTimeout(renderHeatPhotoExperience, Math.max(0, Date.parse(schedule.cutoffAt) - Date.now()) + 1);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) renderHeatPhotoExperience();
    });
    return panel;
  }

  function replaceHeatPlan(items, button, oldGroup, newGroup) {
    if (busy) return;
    setBusy(button, true, 'Saving changes…');
    var cartRequest = function (url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.errors) throw new Error(data.description || data.message || 'Your cart could not be updated.');
          return data;
        });
      });
    };
    cartRequest('/cart.js').then(function (cart) {
      if (!cart.items.some(function (line) { return line.properties && line.properties['_Meal order'] === oldGroup; })) {
        throw new Error('The original plan changed in your cart. Refresh before saving your edits.');
      }
      return cartRequest('/cart/add.js', { items: items });
    }).then(function () {
      return cartRequest('/cart.js');
    }).then(function (cart) {
      var added = cart.items.filter(function (line) { return line.properties && line.properties['_Meal order'] === newGroup; });
      var complete = added.length === items.length && items.every(function (expected) {
        return added.some(function (line) {
          return String(line.variant_id) === String(expected.id) && line.quantity === expected.quantity
            && Object.keys(expected.properties).every(function (key) { return line.properties[key] === expected.properties[key]; });
        });
      });
      if (!complete) throw new Error('Could not confirm every revised plan and extra in your cart. The original plan remains.');
      var updates = Object.fromEntries(cart.items.filter(function (line) { return line.properties && line.properties['_Meal order'] === oldGroup; }).map(function (line) { return [line.key, 0]; }));
      return cartRequest('/cart/update.js', { updates: updates });
    }).then(function (cart) {
      if (cart.items.some(function (line) { return line.properties && line.properties['_Meal order'] === oldGroup; })) {
        throw new Error('The original plan is still in your cart. Review your cart before paying.');
      }
      toast('Your revised plan is in the cart.', false);
      window.location.assign('/cart');
    }).catch(function (error) {
      /* A failed removal or lost response may leave both plans. Keep the original plan and
       * remove only this attempt's new group when the current cart confirms both exist. */
      cartRequest('/cart.js').then(function (cart) {
        var hasOld = cart.items.some(function (line) { return line.properties && line.properties['_Meal order'] === oldGroup; });
        var hasNew = cart.items.some(function (line) { return line.properties && line.properties['_Meal order'] === newGroup; });
        if (hasNew && !hasOld) { window.location.assign('/cart'); return; }
        if (!hasOld || !hasNew) return;
        var updates = Object.fromEntries(cart.items.filter(function (line) { return line.properties && line.properties['_Meal order'] === newGroup; }).map(function (line) { return [line.key, 0]; }));
        return cartRequest('/cart/update.js', { updates: updates });
      }).catch(function () {
        toast('Your cart could not be reconciled automatically. Review it before paying.', true);
      }).finally(function () {
        setBusy(button, false);
        toast(error.message || 'Your changes could not be saved. Review your cart before paying.', true);
      });
    });
  }

  function addHeatSelection(panel, button) {
    var rows = selectionRows();
    var count = rows.reduce(function (sum, row) { return sum + row.quantity; }, 0);
    var size = heatPlanSize;
    var pickup = validateHeatDate(panel);
    if (!pickup) return;
    if (!count) return toast('Pick ' + size + ' meals to claim your plan.', true);
    if (count % size !== 0) return toast('Plans come in sets of ' + size + '. Select ' + (size - (count % size)) + ' more, or remove ' + (count % size) + '.', true);

    var plan = heatPlanProduct(size);
    var planVariant = plan && plan.variants && plan.variants.find(function (variant) { return variant.available !== false; });
    if (!planVariant) return toast('The ' + size + '-meal plan is not connected or is unavailable.', true);

    var baseProperties = { 'Plan': size + ' meals · $' + heatPlanPrice(size) };
    var mealOrderId = crypto.randomUUID();
    var units = [];
    rows.forEach(function (row) { for (var index = 0; index < row.quantity; index += 1) units.push(row.name); });
    var items = [];
    var groups = units.length / size;
    for (var group = 0; group < groups; group += 1) {
      var properties = Object.assign({}, baseProperties, heatPickupProperties(pickup.schedule, heatChosenSlot(panel, pickup.schedule.window), plan.handle, mealOrderId, 'main'));
      if (groups > 1) properties['Plan group'] = (group + 1) + ' of ' + groups;
      units.slice(group * size, group * size + size).forEach(function (name, index) { properties['Meal ' + (index + 1)] = name; });
      items.push({ id: String(planVariant.id), quantity: 1, properties: properties });
    }
    /* Add-ons ride along on the same call, as their own line items - they are extras, not
     * part of the plan, and must never be counted into the 5 or 7. */
    var extras = 0;
    heatAddonProducts().forEach(function (addon) {
      var quantity = heatAddons[addon.handle] || 0;
      if (!quantity) return;
      extras += quantity;
      items.push({
        id: String(addon.variantId),
        quantity: quantity,
        properties: Object.assign(
          { 'Added to': size + '-meal Heat & Eat plan' },
          heatPickupProperties(pickup.schedule, heatChosenSlot(panel, pickup.schedule.window), plan.handle, mealOrderId, 'addon')
        )
      });
    });
    if (heatEditing) {
      replaceHeatPlan(items, button, heatEditing.group, mealOrderId);
    } else {
      addItems(items, button, 'Your ' + size + '-meal plan' + (extras ? ' and ' + extras + ' extra' + (extras === 1 ? '' : 's') : '') + ' is in the cart for ' + pickup.schedule.pickupLabel + '.');
    }
  }

  /* A dish keeps its photograph in the theme, not on the product record, so the case can be
   * re-shot without a product edit and the menu page and this page never drift apart. Keys in
   * config.mealPhotos are slug fragments; a dish matches when its own slug contains one. */
  function mealPhoto(title) {
    var photos = config.mealPhotos;
    if (!photos) return null;
    var slug = String(title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    /* Longest key first, so a specific key beats a shorter one it contains: "spaghetti with
     * meatballs" must not pick up the photo of the meatball container. */
    var keys = Object.keys(photos).sort(function (a, b) { return b.length - a.length; });
    for (var index = 0; index < keys.length; index += 1) {
      if (slug.indexOf(keys[index]) !== -1) return photos[keys[index]];
    }
    return null;
  }

  /* The last row of a 16-card grid is never full at three or four across. Rather than leave
   * the gap, it carries the one thing nobody thinks to ask for. It links rather than adds:
   * the choosing happens in the panel, where the price lands next to the plan total. */
  function heatAddonTeaser() {
    var items = heatAddonProducts();
    if (!items.length) return '';
    /* "From" is the cheapest SWEET add-on, not the cheapest add-on: the tile is about
     * dessert, and a price belonging to a salad would be the wrong number under it. */
    var sweets = items.filter(function (item) { return /tiramisu|cannoli/i.test(item.handle || ''); });
    var priced = sweets.length ? sweets : items;
    var cheapest = priced.reduce(function (low, item) {
      return low === null || Number(item.price) < Number(low) ? item.price : low;
    }, null);
    var tiles = (config.dessertTiles || []).slice(0, 4);
    return '' +
      '<div class="bc-heat-photo__card bc-heat-addon-teaser" data-bc-heat-addon-teaser>' +
        (tiles.length === 4
          ? '<div class="bc-heat-addon-teaser__thumbs" aria-hidden="true">' +
              tiles.map(function (tile) {
                return '<img src="' + escapeHtml(tile.src) + '" alt="" loading="lazy" width="360" height="360">';
              }).join('') +
            '</div>'
          : '') +
        '<div class="bc-heat-photo__card-body">' +
          '<span class="bc-heat-addon-teaser__eyebrow">Not included \u00b7 extra</span>' +
          '<h3>Finish with something sweet</h3>' +
          '<p>Tiramisu or cannoli can ride along in the same pickup, from ' +
            escapeHtml(heatMoney(cheapest)) + ' on top of your plan. The rest of the pastry ' +
            'case is at the counter when you collect.</p>' +
          '<div class="bc-heat-photo__card-footer">' +
            '<button class="bc-heat-photo__add" type="button" data-bc-heat-addon-jump>See the add-ons</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function heatMealCard(product) {
    var tags = product.tags || [];
    /* Only a real dietary fact earns a label. "Heat & Eat" on a Heat & Eat card is the section
     * heading repeated on every item, and it was drawn over the photograph, where a label is
     * hardest to read and most in the way of the food. */
    var badge = tags.indexOf('vegan') !== -1 ? 'Vegan' : (tags.indexOf('vegetarian') !== -1 ? 'Vegetarian' : '');
    // Only for dishes tagged gluten-free in Shopify by the owner; never inferred from the name.
    if (tags.indexOf('gluten-free') !== -1) badge = badge ? badge + ' · Gluten-free' : 'Gluten-free';
    var photo = mealPhoto(product.handle || product.title);
    var image = (photo && photo.src) || product.featuredImage || (config.assets && config.assets['img/deli-watercolor.webp']) || '';
    var title = cleanProductTitle(product.title);
    var handle = escapeHtml(product.handle);
    var safeTitle = escapeHtml(title);
    var available = product.variants && product.variants.some(function (variant) { return variant.available !== false; });

    /* A quantity, not a sentence. "1 in your plan" over "Remove" over "Add another" took three
     * lines and a 96px-tall pair of buttons to say what a stepper says in one row - and the number
     * itself, the thing somebody is actually tracking, was the smallest part of it. An earlier
     * stepper was pulled for overflowing these cards; it fits now that the photograph is a
     * thumbnail and the repeated "chef-made in our kitchen" line has gone. */
    var controls = available
      ? '<button class="bc-heat-photo__add" type="button" data-bc-heat-add data-bc-heat-step="1" data-product-handle="' + handle + '" aria-label="Add ' + safeTitle + ' to your plan">Add to my plan</button>' +
        '<div class="bc-heat-photo__qty" data-bc-heat-adjust hidden>' +
          '<button type="button" data-bc-heat-step="-1" data-product-handle="' + handle + '" aria-label="Remove one ' + safeTitle + '">&minus;</button>' +
          '<strong data-bc-heat-card-count aria-live="polite">1</strong>' +
          '<button type="button" data-bc-heat-step="1" data-product-handle="' + handle + '" aria-label="Add another ' + safeTitle + '">+</button>' +
        '</div>'
      : '<span class="bc-heat-photo__card-note">Not available this week</span>';

    return '<article class="bc-heat-photo__card" data-bc-heat-meal-card="' + handle + '">' +
      '<div class="bc-heat-photo__media">' +
        '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml((photo && photo.alt) || (title + ' from the Buon Cibo Heat & Eat menu')) + '" loading="lazy">' +
      '</div>' +
      '<div class="bc-heat-photo__card-body">' +
        // The dish, one line about it, and the dietary label beside the name where it can be read.
        '<div class="bc-heat-photo__card-text">' +
          /* The label sits on its own line under the name, always. Inline after the title it
           * landed beside the short names and wrapped under the long ones, so it moved about as
           * you went down the column - which is exactly what a label must not do. */
          '<h3>' + safeTitle + '</h3>' +
          (badge ? '<p class="bc-heat-photo__diet">' + escapeHtml(badge) + '</p>' : '') +
          (photo && photo.note ? '<p class="bc-heat-photo__note">' + escapeHtml(photo.note) + '</p>' : '') +
        '</div>' +
        '<div class="bc-heat-photo__card-footer">' + controls + '</div>' +
      '</div>' +
    '</article>';
  }

  function buildHeatPhotoExperience() {
    var section = mount.querySelector('#meals');
    if (!section || section.querySelector('[data-bc-heat-photo-builder]')) return;
    var headingRow = section.firstElementChild;
    Array.from(section.children).forEach(function (child) { if (child !== headingRow) child.remove(); });
    // The heading used to get "Pick any five or any seven. Same price whichever you choose."
    // written into it here. It restated step 01 of How it works and sat awkwardly beside the
    // heading, so it goes. Removed rather than left blank so a stray empty <span> does not
    // sit in the heading row affecting its layout.
    var note = headingRow && headingRow.querySelector('span');
    if (note) note.remove();

    var builder = document.createElement('div');
    builder.className = 'bc-heat-photo';
    builder.setAttribute('data-bc-heat-photo-builder', '');
    builder.innerHTML =
      '<div class="bc-heat-photo__intro"><div class="bc-heat-photo__intro-text"><p>Add any dish to your plan, two of the same if you like. Five meals is $' + heatPlanPrice(5) + ', seven is $' + heatPlanPrice(7) + '. Order by ' + escapeHtml(heatPickupSchedule().cutoffLabel) + ', ' + escapeHtml(heatPickupSchedule().cutoffTimeLabel) + ' and pick up ' + escapeHtml(heatPickupSchedule().pickupLabel) + ', ' + heatPickupSchedule().window + '.</p>' +
      '<p class="bc-heat-photo__sides">Pasta shapes rotate based on availability and may differ from the photo.</p>' +
      '<p class="bc-heat-photo__where">Plans are ordered online only. You are always welcome to come in and see what is in the case that day, or call <a href="tel:8582656702">(858) 265-6702</a> to ask what is ready to take home.</p>' +
      '</div><span>Cold · Ready to reheat · Monday pickup only</span></div>' +
      '<div class="bc-heat-photo__layout">' +
        '<div class="bc-heat-photo__catalog">' + heatMealProducts().map(heatMealCard).join('') + heatAddonTeaser() + '</div>' +
        '<aside class="bc-heat-photo__summary" aria-label="Heat and Eat order summary">' +
          '<span class="bc-heat-photo__kicker">Your order</span>' +
          '<h3 data-bc-heat-count>Your order</h3>' +
          '<div class="bc-heat-photo__selected" data-bc-heat-selected-list></div>' +
          '<div data-bc-heat-panel-slot></div>' +
          '<button class="bc-heat-photo__clear" type="button" data-bc-heat-clear>Start over</button>' +
        '</aside>' +
      '</div>';
    section.appendChild(builder);
    builder.querySelector('[data-bc-heat-panel-slot]').appendChild(heatCheckoutPanel());
    builder.addEventListener('click', function (event) {
      var planControl = event.target.closest('[data-bc-heat-plan]');
      if (planControl) {
        event.preventDefault();
        event.stopPropagation();
        heatPlanSize = Number(planControl.getAttribute('data-bc-heat-plan')) === 7 ? 7 : 5;
        renderHeatPhotoExperience();
        return;
      }
      var step = event.target.closest('[data-bc-heat-step]');
      if (step) {
        event.preventDefault();
        event.stopPropagation();
        var handle = step.getAttribute('data-product-handle');
        var nextQuantity = Math.max(0, Math.min(20, (heatSelections[handle] || 0) + Number(step.getAttribute('data-bc-heat-step'))));
        if (nextQuantity) heatSelections[handle] = nextQuantity;
        else delete heatSelections[handle];
        renderHeatPhotoExperience();
        return;
      }
      var addonStep = event.target.closest('[data-bc-addon-step]');
      if (addonStep) {
        event.preventDefault();
        event.stopPropagation();
        var addonHandle = addonStep.getAttribute('data-bc-addon-handle');
        var addonQuantity = Math.max(0, Math.min(12, (heatAddons[addonHandle] || 0) + Number(addonStep.getAttribute('data-bc-addon-step'))));
        if (addonQuantity) heatAddons[addonHandle] = addonQuantity;
        else delete heatAddons[addonHandle];
        renderHeatPhotoExperience();
        return;
      }
      if (event.target.closest('[data-bc-heat-clear]')) {
        event.preventDefault();
        event.stopPropagation();
        heatSelections = {};
        /* "Start over" means the extras too. Leaving them selected brought a tiramisu back
         * the moment five new meals were picked, with nobody having asked for it. */
        heatAddons = {};
        renderHeatPhotoExperience();
        return;
      }
      /* The teaser only points at the add-ons; it never adds anything. If the plan is not
       * claimable yet the block is still closed, so say what unlocks it rather than
       * scrolling somebody to a panel with nothing in it. */
      if (event.target.closest('[data-bc-heat-addon-jump]')) {
        event.preventDefault();
        event.stopPropagation();
        var host = mount.querySelector('[data-bc-heat-addons]');
        var panel = mount.querySelector('[data-bc-heat-checkout]');
        if (host && !host.hidden) {
          host.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var first = host.querySelector('[data-bc-addon-step="1"]');
          if (first) first.focus({ preventScroll: true });
        } else if (panel) {
          panel.scrollIntoView({ block: 'center', behavior: 'smooth' });
          toast('Claim your ' + heatPlanSize + '-meal plan first, then the add-ons open up.', true);
        }
      }
    }, true);
    renderHeatPhotoExperience();
    restoreHeatEdit();
  }

  function renderTrayPanel(panel) {
    if (!panel) return;
    var handle = panel.getAttribute('data-bc-tray-commerce');
    var product = heatProductByHandle(handle);
    if (!product) return;
    var variant = product.variants.find(function (item) { return String(item.id) === panel.querySelector('[data-bc-tray-variant]').value; });
    var quantity = Math.max(1, Number(panel.querySelector('[data-bc-tray-quantity]').value) || 1);
    var button = panel.querySelector('[data-bc-commerce-action="tray-add"]');
    if (button && variant) button.textContent = 'Add tray · ' + money(cents(variant.price) * quantity);
    var dateField = panel.querySelector('[data-bc-tray-date]');
    var timeField = panel.querySelector('[data-bc-tray-time]');
    if (dateField && timeField) {
      var now = Date.now(), earliest = trayEarliestDate(now);
      dateField.min = earliest;
      Array.from(panel.querySelectorAll('[data-bc-tray-day]')).forEach(function (day) { day.disabled = day.dataset.bcTrayDay < earliest; });
      Array.from(timeField.options).forEach(function (option) { option.disabled = !trayPickupValid(dateField.value, option.value, now); });
      var selected = timeField.selectedOptions[0];
      if (!selected || selected.disabled) {
        var next = Array.from(timeField.options).find(function (option) { return !option.disabled; });
        timeField.value = next ? next.value : '';
      }
      if (button) button.disabled = !variant || variant.available === false || !trayPickupValid(dateField.value, timeField.value, now);
    }
    var quantityNode = panel.querySelector('[data-bc-tray-quantity-output]');
    if (quantityNode) quantityNode.textContent = quantity;
  }

  function trayPanel(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var availableVariants = product.variants.filter(function (variant) { return variant.available !== false; });
    var panel = document.createElement('div');
    panel.className = 'bc-commerce bc-tray-commerce';
    panel.setAttribute('data-bc-tray-commerce', product.handle);
    panel.innerHTML =
      '<label class="bc-commerce__field"><span>Tray size</span><select data-bc-tray-variant>' + product.variants.map(function (variant) {
        return '<option value="' + escapeHtml(variant.id) + '"' + (variant.available === false ? ' disabled' : '') + '>' + escapeHtml(variant.title) + ' \u00b7 ' + escapeHtml(money(variant.price)) + (variant.available === false ? ' \u00b7 unavailable' : '') + '</option>';
      }).join('') + '</select></label>' +
      '<div class="bc-tray-commerce__field"><span class="bc-commerce__label">Pickup day</span>' +
        '<div class="bc-tray-days" role="group" aria-label="Pickup day">' +
          trayDayOptions().map(function (day, index) {
            return '<button type="button" class="bc-tray-days__day" data-bc-tray-day="' + escapeHtml(day.value) + '" aria-pressed="' + (index === 0 ? 'true' : 'false') + '">' +
              '<span>' + escapeHtml(day.name) + '</span><strong>' + day.date + '</strong></button>';
          }).join('') +
          '<button type="button" class="bc-tray-days__more" data-bc-tray-more aria-expanded="false">Another day</button>' +
        '</div>' +
        '<input type="date" class="bc-tray-days__input is-collapsed" min="' + escapeHtml(trayEarliestDate()) + '" value="' + escapeHtml(trayEarliestDate()) + '" data-bc-tray-date aria-label="Pickup date">' +
      '</div>' +
      '<label class="bc-commerce__field"><span>Pickup time</span><select data-bc-tray-time>' + trayTimeOptions().map(function (slot) {
        return '<option value="' + escapeHtml(slot.value) + '"' + (slot.value === '17:00' ? ' selected' : '') + '>' + escapeHtml(slot.label) + '</option>';
      }).join('') + '</select></label>' +
      /* Two lines, no button, no disclosure to open. The phone number is the link inside the
       * sentence that needs it, and the sentence answers both questions somebody has at this
       * point: can I have one today, and why does the form say tomorrow. */
      '<p class="bc-tray-note">Need one today? <a href="tel:8582656702">Call now</a> to see what is in the freezer. A tray made fresh needs at least 24 hours before pickup.</p>' +
      '<div class="bc-tray-commerce__quantity"><span>Quantity</span><div class="bc-heat-photo__stepper" role="group" aria-label="Tray quantity"><button type="button" data-bc-tray-step="-1" aria-label="Remove one tray">−</button><output data-bc-tray-quantity-output>1</output><button type="button" data-bc-tray-step="1" aria-label="Add one tray">+</button><input type="hidden" value="1" data-bc-tray-quantity></div></div>' +
      '<button class="bc-commerce__button" type="button" data-bc-commerce-action="tray-add"' + (availableVariants.length ? '' : ' disabled') + '>Add tray</button>';
    panel.addEventListener('change', function () { renderTrayPanel(panel); });
    panel.addEventListener('click', function (event) {
      var step = event.target.closest('[data-bc-tray-step]');
      if (!step) return;
      event.preventDefault();
      event.stopPropagation();
      var quantity = panel.querySelector('[data-bc-tray-quantity]');
      quantity.value = Math.max(1, Math.min(12, Number(quantity.value || 1) + Number(step.getAttribute('data-bc-tray-step'))));
      renderTrayPanel(panel);
    }, true);
    panel.querySelector('[data-bc-commerce-action]').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var variant = product.variants.find(function (item) { return String(item.id) === panel.querySelector('[data-bc-tray-variant]').value; });
      var date = panel.querySelector('[data-bc-tray-date]').value;
      var timeControl = panel.querySelector('[data-bc-tray-time]');
      var timeLabel = timeControl ? timeControl.options[timeControl.selectedIndex].textContent : '';
      var quantity = Math.max(1, Math.min(12, Number(panel.querySelector('[data-bc-tray-quantity]').value) || 1));
      if (!variant || variant.available === false || !date) return toast('Choose an available tray size and pickup date.', true);
      if (!timeControl || !trayPickupValid(date, timeControl.value)) return toast('Trays need at least 24 hours before pickup. Choose a later date and time.', true);
      addItems([{ id: String(variant.id), quantity: quantity, properties: trayPickupProperties(date, timeLabel, product.handle) }], event.currentTarget, cleanProductTitle(product.title) + ' is in the cart.');
    });
    window.setTimeout(function () { renderTrayPanel(panel); }, 0);
    return panel;
  }

  function connectHeatEat() {
    if (config.pageKey !== 'heat-eat' || !(products.heatEat || []).length) return;
    var schedule = heatPickupSchedule();
    Array.from(mount.querySelectorAll('[data-bc-heat-next-cutoff]')).forEach(function (n) { n.textContent = '· next: ' + schedule.cutoffLabel.replace(/^\w+, /, '') + ', ' + schedule.cutoffTimeLabel; });
    Array.from(mount.querySelectorAll('[data-bc-heat-next-pickup]')).forEach(function (n) { n.textContent = '· next: ' + schedule.pickupLabel.replace(/^\w+, /, ''); });
    buildHeatPhotoExperience();

    var traysSection = mount.querySelector('#trays');
    if (traysSection) {
      Array.from(traysSection.querySelectorAll('article')).forEach(function (article) {
        var heading = article.querySelector('h3');
        if (!heading) return;
        var product = heatProductByName(heading.textContent || '', 'bc-heat-eat-tray');
        if (!product) return;
        if (!article.querySelector('[data-bc-tray-photo]')) {
          var image = document.createElement('img');
          image.setAttribute('data-bc-tray-photo', '');
          image.src = product.featuredImage || (config.assets && config.assets['img/lasagna-sunday.png']) || '';
          image.alt = cleanProductTitle(product.title) + ' family-style tray';
          image.loading = 'lazy';
          article.insertBefore(image, article.firstChild);
        }
        var existingPanel = article.querySelector('[data-bc-tray-commerce]');
        if (!existingPanel) {
          var panel = trayPanel(product);
          if (panel) article.appendChild(panel);
        } else {
          renderTrayPanel(existingPanel);
        }
      });
    }
  }

  /*
   * The preserved Design Code runtime may clone newly inserted nodes while it
   * indexes the page. Keep one delegated commerce listener on the stable mount
   * so the Shopify actions survive that clone without changing the design DOM.
   */
  mount.addEventListener('click', function (event) {
    var heatPlanControl = event.target.closest && event.target.closest('[data-bc-heat-plan]');
    if (heatPlanControl && mount.contains(heatPlanControl)) {
      event.preventDefault();
      heatPlanSize = Number(heatPlanControl.getAttribute('data-bc-heat-plan')) === 5 ? 5 : 7;
      renderHeatPhotoExperience();
      /* The plan controls in the panel are buttons and stay put. The two cards at the top of the
       * page are links to the meals, and choosing a plan there should still take you there. */
      var jumpTo = heatPlanControl.getAttribute('href');
      if (jumpTo && jumpTo.charAt(0) === '#') {
        var target = document.querySelector(jumpTo);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    /* The tray pickup day. On the mount rather than on the panel, because the concept runtime
     * clones the panel while it indexes the page and a listener bound to the panel does not
     * survive that clone - which is why the chips looked live and did nothing. */
    var trayDay = event.target.closest && event.target.closest('[data-bc-tray-day]');
    if (trayDay && mount.contains(trayDay)) {
      event.preventDefault();
      var dayPanel = trayDay.closest('[data-bc-tray-commerce]');
      var dayField = dayPanel && dayPanel.querySelector('[data-bc-tray-date]');
      if (dayField) {
        dayField.value = trayDay.getAttribute('data-bc-tray-day');
        dayField.classList.add('is-collapsed');
      }
      Array.prototype.forEach.call(dayPanel.querySelectorAll('[data-bc-tray-day]'), function (node) {
        node.setAttribute('aria-pressed', String(node === trayDay));
      });
      var moreControl = dayPanel.querySelector('[data-bc-tray-more]');
      if (moreControl) moreControl.setAttribute('aria-expanded', 'false');
      renderTrayPanel(dayPanel);
      return;
    }

    var trayMore = event.target.closest && event.target.closest('[data-bc-tray-more]');
    if (trayMore && mount.contains(trayMore)) {
      event.preventDefault();
      var morePanel = trayMore.closest('[data-bc-tray-commerce]');
      var moreField = morePanel && morePanel.querySelector('[data-bc-tray-date]');
      if (moreField) {
        moreField.classList.remove('is-collapsed');
        Array.prototype.forEach.call(morePanel.querySelectorAll('[data-bc-tray-day]'), function (node) {
          node.setAttribute('aria-pressed', 'false');
        });
        trayMore.setAttribute('aria-expanded', 'true');
        if (moreField.showPicker) { try { moreField.showPicker(); } catch (error) { moreField.focus(); } }
        else moreField.focus();
      }
      return;
    }

    var heatStep = event.target.closest && event.target.closest('[data-bc-heat-step]');
    if (heatStep && mount.contains(heatStep)) {
      event.preventDefault();
      var handle = heatStep.getAttribute('data-product-handle');
      var nextQuantity = Math.max(0, Math.min(20, (heatSelections[handle] || 0) + Number(heatStep.getAttribute('data-bc-heat-step'))));
      if (nextQuantity) heatSelections[handle] = nextQuantity;
      else delete heatSelections[handle];
      renderHeatPhotoExperience();
      return;
    }

    var heatAddonStep = event.target.closest && event.target.closest('[data-bc-addon-step]');
    if (heatAddonStep && mount.contains(heatAddonStep)) {
      event.preventDefault();
      var addonHandle = heatAddonStep.getAttribute('data-bc-addon-handle');
      var addonQuantity = Math.max(0, Math.min(12, (heatAddons[addonHandle] || 0) + Number(heatAddonStep.getAttribute('data-bc-addon-step'))));
      if (addonQuantity) heatAddons[addonHandle] = addonQuantity;
      else delete heatAddons[addonHandle];
      renderHeatPhotoExperience();
      return;
    }

    var clearHeat = event.target.closest && event.target.closest('[data-bc-heat-clear]');
    if (clearHeat && mount.contains(clearHeat)) {
      event.preventDefault();
      heatSelections = {};
      heatAddons = {};
      renderHeatPhotoExperience();
      return;
    }

    var trayStep = event.target.closest && event.target.closest('[data-bc-tray-step]');
    if (trayStep && mount.contains(trayStep)) {
      event.preventDefault();
      var trayStepPanel = trayStep.closest('[data-bc-tray-commerce]');
      var trayQuantity = trayStepPanel && trayStepPanel.querySelector('[data-bc-tray-quantity]');
      if (trayQuantity) {
        trayQuantity.value = Math.max(1, Math.min(12, Number(trayQuantity.value || 1) + Number(trayStep.getAttribute('data-bc-tray-step'))));
        renderTrayPanel(trayStepPanel);
      }
      return;
    }

    var button = event.target.closest && event.target.closest('[data-bc-commerce-action]');
    if (!button || !mount.contains(button) || busy) return;
    var action = button.getAttribute('data-bc-commerce-action');
    var panel;
    var variant;
    var quantity;

    if (action === 'preorder-add') {
      panel = button.closest('[data-bc-preorder-commerce]');
      if (!panel) return;
      var kind = panel.getAttribute('data-bc-preorder-commerce') || '';
      var preorderProduct = /sunday/i.test(kind) ? products.secondary : products.primary;
      if (!preorderProduct) return;
      variant = preorderProduct.variants.find(function (item) {
        return String(item.id) === panel.querySelector('[data-bc-preorder-variant]').value;
      });
      quantity = Math.max(1, Math.min(12, Number(panel.querySelector('[data-bc-preorder-quantity]').value) || 1));
      if (!variant) return;
      event.preventDefault();
      addItems([{
        id: String(variant.id),
        quantity: quantity,
        properties: {
          'Pickup timing': 'Scheduled preorder',
          'Requested pickup window': variant.title,
          'Fulfillment': 'Pickup at Buon Cibo',
        },
      }], button, preorderProduct.title + ' is in the cart.');
      return;
    }

    if (action === 'heat-add') {
      panel = button.closest('[data-bc-heat-checkout]');
      if (!panel) return;
      event.preventDefault();
      addHeatSelection(panel, button);
      return;
    }

    if (action === 'tray-add') {
      panel = button.closest('[data-bc-tray-commerce]');
      if (!panel) return;
      var trayProduct = (products.heatEat || []).find(function (product) {
        return product.handle === panel.getAttribute('data-bc-tray-commerce');
      });
      if (!trayProduct) return;
      variant = trayProduct.variants.find(function (item) {
        return String(item.id) === panel.querySelector('[data-bc-tray-variant]').value;
      });
      var date = panel.querySelector('[data-bc-tray-date]').value;
      var timeControl = panel.querySelector('[data-bc-tray-time]');
      var timeLabel = timeControl ? timeControl.options[timeControl.selectedIndex].textContent : '';
      quantity = Math.max(1, Math.min(12, Number(panel.querySelector('[data-bc-tray-quantity]').value) || 1));
      if (!variant || variant.available === false || !date) return toast('Choose an available tray size and pickup date.', true);
      event.preventDefault();
      /* Trays run on their own clock - the day and time chosen in this panel, a day's notice at
       * least - not the Monday plan window the heat-and-eat bundle uses. This handler is the one
       * that actually fires, because the runtime clones the panel and drops the listener bound to
       * it, so it has to be exactly as careful as that listener was. */
      if (!timeControl || !trayPickupValid(date, timeControl.value)) return toast('Trays need at least 24 hours before pickup. Choose a later date and time.', true);
      addItems([{
        id: String(variant.id),
        quantity: quantity,
        properties: trayPickupProperties(date, timeLabel, trayProduct.handle),
      }], button, cleanProductTitle(trayProduct.title) + ' is in the cart.');
    }
  });

  mount.addEventListener('change', function (event) {
    var panel = event.target.closest && event.target.closest('[data-bc-heat-checkout]');
    if (panel) {
      renderHeatPanel(panel);
      return;
    }

    var trayChangePanel = event.target.closest && event.target.closest('[data-bc-tray-commerce]');
    if (trayChangePanel && mount.contains(trayChangePanel)) renderTrayPanel(trayChangePanel);
  });

  var scheduled = false;
  function connect() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      pruneDuplicateCommercePanels();
      connectPreorder();
      connectGuestSlider();
      connectHeatEat();
    });
  }

  var observer = new MutationObserver(connect);
  observer.observe(mount, { childList: true, subtree: true, characterData: true });
  connect();
})();
